/*
 * Copyright (c) 2017.  Bakos Energy (Apeldoorn NL), Spin in het Web (Apeldoorn NL)
 */

/**
 * SPIN IN HET WEB APELDOORN
 * User: Jelmer Jellema
 * Date: 28-5-2017
 * Time: 05:49
 *
 * componenten voor de schermopbouw
 *
 * Is tevens een container voor de states eronder, dus onze scope valt door
 *
 */

angular.module('myApp.schermopbouw', ['sihw.sihwlog', 'dl.api'])
//navbar
    .directive('mainscherm', ['$rootScope', '$timeout', 'approuter', 'sihwlog', 'api', function ($rootScope, $timeout, approuter, sihwlog, api) {
        let log = sihwlog.logLevel('debug');
        return {
            //directive definitie
            restrict: 'E',
            //element
            templateUrl: "components/schermopbouw/mainscherm.html",
            scope: true, //overerven
            link: function ($scope, el, attr) {
                log.debug('Init mainscherm');

                $scope.balk = {};

                //regel autoscroll beter dan autoscroll, want navhegiht
                $rootScope.$on('$stateChangeSuccess', function () {
                    document.body.scrollTop = document.documentElement.scrollTop = $scope.navheight + 'px';
                });

                $scope.nieuwMateriaal = function() {
                    approuter.go('edit',{id: null},{reload: true});
                };

                /**
                 * Init het mainscherm
                 */
                function init() {
                    $scope.navheight = 50; //eerst maar eens
                    $(window).on('resize', setMainheight);
                    //en even aan het begin wachten tot mainnav een height heeft. Dat kan even duren,
                    //ivm de gekke laadvolgorde (dom al ready, dan pas template)
                    $(function () {
                        let checkheight = function () {
                            if ($('#mainnav').height()) {
                                setMainheight();
                            }
                            else {
                                $timeout(checkheight, 20);
                            }
                        };
                        checkheight();
                    })
                }

                /**
                 * Bij resize opnieuw genoeg ruimte rond de nav
                 */
                function setMainheight() {
                    $scope.navheight = $('#mainnav').height();
                    $scope.$apply();
                }

                init();
            }
        }
    }]);